import React from 'react';

const ModulesContainerDesktop = (props) => {
    return (
        // <div style={{display: 'flex', flex: 1, justifyContent: 'center', height: '100%' }}>
        <div id={'ModulesContainerDesktop-Outer'} style={{ display: 'flex', flexDirection: 'column', flex: 1, height: 'calc( 100vh - 73px )' }}>
            {/* <div style={{ display: 'flex', flex: 1, justifyContent: 'space-between', maxWidth: 1180, paddingLeft: 60, paddingRight: 60 }}> */}
            <div id={'ModulesContainerDesktop-Inner'} style={{display: 'flex', flex: 1, overflowY: 'hidden', justifyContent: 'space-between' }}>
                {props.children}
            </div>
        </div>
    );
}

export default ModulesContainerDesktop;


// WEBPACK FOOTER //
// ./src/js/components/ModulesContainerDesktop.jsx